import { createService } from '@/helpers/hasura'

import gql from 'graphql-tag'

import { AddressFragment } from '@/helpers/api/fragments'

const output = `
  ...Address
`
const fragments = gql`
  ${AddressFragment}
`

const allowedFields = [
  'account_id',
  'street',
  'number',
  'line1',
  'zipcode',
  'city',
  'country_code',
  'company_name',
  'attn',
  'is_default',
  'is_shipping_address',
  'rating',
  'is_archived'
]

export default config => {
  const service = createService({
    ...config,
    table: 'address',
    defaultFilters: [],
    defaultOutput: output,
    defaultFragments: fragments,
    defaultOrderBy: [
      { is_default: 'desc' },
      { rating: 'desc' },
      { company_name: 'asc' }
    ],
    defaultSearchBy: ['city', 'company_name'],
    allowedFields
  })

  return {
    ...service
  }
}
